import React from 'react';
import cn from 'classnames';
import { IBaseElementProps } from 'tbk-components/src/components/BasicElement';
import Image, { IImage } from 'tbk-components/src/components/Image';
import Nav, { NavItem } from 'tbk-components/src/components/Nav';
import SocialIcons, { ISocialIconsProps } from '../SocialIcons';

export interface ILandingPageFooterProps extends IBaseElementProps {
	logo?: IImage;
	logoURL?: string;
	bottomMenu?: NavItem[];
	copyrightText?: string;
	socialIcons?: ISocialIconsProps;
}

/**
 * Landing Page Footer
 * @icon list-view
 * @block
 */
const LandingPageFooter: React.FC<ILandingPageFooterProps> = ({
	logo,
	logoURL,
	bottomMenu,
	copyrightText,
	socialIcons,
	className,
	classNames = [],
}) => (
	<div className={className || cn('landing-page-footer', ...classNames)}>
		<div className="landing-page-footer__container container-fluid">
			{logo && logoURL && (
				<a className="landing-page-footer__logo-link" href={logoURL}>
					<Image
						{...logo}
						className="landing-page-footer__logo-img"
					/>
				</a>
			)}
			{bottomMenu && (
				<Nav
					navItems={bottomMenu}
					collapseEnabled={false}
					dropdownEnabled
					classNames={['landing-page-footer__bottom-nav']}
				/>
			)}
			{copyrightText && (
				<p className="landing-page-footer__copyright">
					{copyrightText}
				</p>
			)}
			{socialIcons && (
				<SocialIcons
					className="landing-page-footer__bottom--social-icons list-unstyled"
					{...socialIcons}
				/>
			)}
		</div>
	</div>
);

export default LandingPageFooter;
